import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getUserListApi } from '@src/api';
import { UserListParams } from './userList';

const getUserList = createAsyncThunk(
  'users/getUserList',
  async (
    {
      page = 1,
      limit = 20,
      sortBy = [''],
      searchBy = 'name',
      search,
      filter = {},
    }: UserListParams,
    { rejectWithValue }
  ) => {
    try {
      const response = await getUserListApi({
        page,
        limit,
        sortBy,
        searchBy,
        search,
        filter,
      });

      return response.result.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export default getUserList;
